export var DEFAULT_TRANSITION_TIME = '.4s';
export var DEFAULT_TRANSITION_TIMING_FUNCTION = 'cubic-bezier(.68,.12,.24,.99)';
export var DEFAULT_TRANSITION_MAX_HEIGHT = '100vh';
